module.exports = __webpack_public_path__ + "static/media/news-default.34002107.jpg";